import { h, Component, Host, Element } from "@stencil/core";
import pfx from "../../../../../utils/style-class-prefix-helper";
// import { InitLogging } from "../../../../../decorators/init-logging";

@Component({
  tag: "eon-ui-navigation-flyout-divider",
  styleUrl: "navigation-flyout-divider.scss",
  shadow: true
})
export class NavigationFlyoutDivider {
  // @InitLogging() sentryTransaction;

  @Element() hostElement: HTMLEonUiNavigationFlyoutDividerElement;

  render() {
    return (
      <Host>
        <div class={pfx({ divider: true })}></div>
      </Host>
    );
  }
}
